import merge from "lodash/merge";
const DEFAULT_TEXT_COLOR = '#222';
const DEFAULT_NO_DATA_MESSAGE = 'No data.';
function generateChartsTheme(muiTheme, echartsTheme, tooltipPortalContainerId) {
    const primaryTextColor = muiTheme.palette.text?.primary ?? DEFAULT_TEXT_COLOR;
    const valueOrLogAxisTheme = {
        show: true,
        axisLabel: {
            color: primaryTextColor,
            margin: 10
        },
        axisLine: {
            show: false
        },
        splitLine: {
            show: true,
            lineStyle: {
                width: 0.5,
                color: muiTheme.palette.grey[300],
                opacity: 0.6
            }
        }
    };
    const muiConvertedTheme = {
        title: {
            show: false
        },
        textStyle: {
            color: primaryTextColor,
            fontFamily: muiTheme.typography.fontFamily,
            fontSize: 12
        },
        grid: {
            top: 5,
            right: 20,
            bottom: 0,
            left: 20,
            containLabel: true
        },
        color: [
            '#68C7FF',
            '#005BCE',
            '#FF9292',
            '#9C597E',
            '#02B4C1',
            '#816AB5',
            '#98003C'
        ],
        categoryAxis: {
            show: true,
            axisLabel: {
                show: true,
                color: primaryTextColor,
                margin: 10
            },
            axisTick: {
                show: false,
                length: 6,
                lineStyle: {
                    color: muiTheme.palette.grey[600]
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: muiTheme.palette.grey[600]
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    width: 0.5,
                    color: muiTheme.palette.grey[300],
                    opacity: 0.4
                }
            },
            splitArea: {
                show: false,
                areaStyle: {
                    color: [
                        muiTheme.palette.grey[300]
                    ]
                }
            }
        },
        timeAxis: {
            show: true,
            axisLabel: {
                show: true,
                color: primaryTextColor,
                margin: 10
            },
            axisTick: {
                show: false,
                length: 6,
                lineStyle: {
                    color: muiTheme.palette.grey[600]
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: muiTheme.palette.grey[600]
                }
            },
            axisPointer: {
                z: 1,
                label: {
                    margin: 0,
                    padding: 3,
                    backgroundColor: muiTheme.palette.primary.main,
                    borderRadius: 0,
                    color: muiTheme.palette.text.inversePrimary
                }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    width: 0.5,
                    color: muiTheme.palette.grey[300],
                    opacity: 0.4
                }
            },
            splitArea: {
                show: false,
                areaStyle: {
                    color: [
                        muiTheme.palette.grey[300]
                    ]
                }
            }
        },
        valueAxis: {
            ...valueOrLogAxisTheme
        },
        logAxis: {
            ...valueOrLogAxisTheme
        },
        legend: {
            orient: 'horizontal',
            textStyle: {
                color: primaryTextColor
            },
            pageTextStyle: {
                color: muiTheme.palette.grey[600]
            },
            pageIconColor: muiTheme?.palette?.action?.active,
            pageIconInactiveColor: muiTheme?.palette?.action?.disabled
        },
        toolbox: {
            show: true,
            top: 10,
            right: 10,
            iconStyle: {
                borderColor: primaryTextColor
            }
        },
        tooltip: {
            backgroundColor: muiTheme.palette.designSystem?.grey[800],
            borderColor: muiTheme.palette.designSystem?.grey[800],
            textStyle: {
                color: '#fff',
                fontSize: 11
            },
            axisPointer: {
                shadowStyle: {
                    color: 'rgba(210,219,238,0.2)'
                }
            }
        },
        axisPointer: {
            lineStyle: {
                color: muiTheme.palette.grey[500]
            }
        },
        markLine: {
            symbol: 'none',
            symbolSize: 0,
            itemStyle: {
                color: muiTheme.palette.grey[500]
            },
            lineStyle: {
                type: 'dashed',
                width: 1
            }
        },
        line: {
            showSymbol: false,
            symbol: 'circle',
            symbolSize: 4,
            smooth: false,
            lineStyle: {
                width: 1
            },
            emphasis: {
                lineStyle: {
                    width: 1.5
                }
            }
        },
        bar: {
            barMaxWidth: 150,
            itemStyle: {
                borderWidth: 0,
                borderRadius: 0,
                borderColor: muiTheme.palette.grey[300]
            },
            label: {
                show: false,
                color: primaryTextColor
            }
        },
        gauge: {
            detail: {
                fontSize: 18,
                fontWeight: 600,
                valueAnimation: false
            },
            splitLine: {
                distance: 0,
                length: 4,
                lineStyle: {
                    width: 1
                }
            },
            splitNumber: 12
        }
    };
    return {
        theme: muiTheme,
        tooltipPortalContainerId,
        echartsTheme: merge(muiConvertedTheme, echartsTheme),
        noDataOption: {
            title: {
                show: true,
                textStyle: {
                    color: primaryTextColor,
                    fontSize: 16,
                    fontWeight: 400
                },
                text: DEFAULT_NO_DATA_MESSAGE,
                left: 'center',
                top: 'center'
            },
            xAxis: {
                show: false
            },
            yAxis: {
                show: false
            }
        },
        sparkline: {
            width: 2,
            color: '#1976d2'
        },
        container: {
            padding: {
                x: parseInt(muiTheme.spacing(1), 10),
                y: parseInt(muiTheme.spacing(1), 10)
            }
        },
        thresholds: {
            defaultColor: muiTheme.palette.primary.main,
            palette: [
                '#DA7B07',
                muiTheme.palette.error.main
            ],
            labelBackgroundColor: 'rgba(255, 255, 255, 0.8)',
            labelColor: muiTheme.palette.grey[400]
        },
        yAxis: {
            label: {
                chartPadding: parseInt(muiTheme.spacing(1), 10)
            }
        },
        stripedDecal: {
            dashArrayX: [
                1,
                0
            ],
            dashArrayY: [
                4,
                3
            ],
            rotation: -Math.PI / 4,
            color: 'white'
        },
        confidenceBandColor: muiTheme.palette.grey[200]
    };
}
function getNoDataMessage(chartsTheme) {
    return chartsTheme.noDataOption.title.text;
}
export { DEFAULT_NO_DATA_MESSAGE, generateChartsTheme, getNoDataMessage };

//# sourceMappingURL=theme-gen.js.map